import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import classnames from 'classnames'

// Assets
import './Projects.css'

// Components
import Header from '../../components/Header/Header'
import Project from '../../components/Project/Project'

const Year = function (props) {
  return (
    <div className='djs-portfolio__year'>
      <span className='djs-portfolio__year--name'>
        {props.year}
      </span>
    </div>
  )
}

class Projects extends Component {
  constructor (props, context) {
    super(props)

    this.state = {
      projectId: props.match.params.projectId
    }

    this.setupKonami()
  }

  setupKonami () {
    // Adapted from @nestoralvaro at https://gist.github.com/nestoralvaro/1597163

    var konamiCode = [38, 38, 40, 40, 37, 39, 37, 39, 66, 65]
    var konamiDetected = []

    let isKonamiKey = (e) => {
      var evt = e || window.event
      var key = evt.keyCode ? evt.keyCode : evt.which

      var codeOk = true

      konamiDetected.push(key)

      if (konamiDetected.length < konamiCode.length) {
        for (var i = 0, max = konamiDetected.length; i < max; i++) {
          if (konamiDetected[i] !== konamiCode[i]) {
            codeOk = false
          }
        }
        if (!codeOk) {
          konamiDetected = []
          konamiDetected.push(key)
        }
      } else if (konamiDetected.length === konamiCode.length) {
        for (var j = 0, max2 = konamiDetected.length; j < max2; j++) {
          if (konamiDetected[j] !== konamiCode[j]) {
            codeOk = false
          }
        }

        konamiDetected = []

        if (codeOk) {
          document.removeEventListener('keydown', isKonamiKey, false)
          this.revealSecrets()
        }
      } else {
        konamiDetected = []
      }
    }

    document.addEventListener('keydown', isKonamiKey, false)
  }

  revealSecrets () {
    // redux action, set revealSecrets
    this.setState({ revealSecrets: true })
  }

  selectProject (projectId, shouldUpdateHistory = true) {
    // redux action, set selected project.
    this.setState((prevState, props) => {
      if (prevState.projectId === projectId && shouldUpdateHistory) {
        return prevState
      }

      let selectedProject = null
      let projects = [...this.state.projects].map((project) => {
        project.selected = project.id === projectId
        if (project.selected) selectedProject = project
        return project
      })

      if (selectedProject) {
        document.title = `${selectedProject.name.secret || selectedProject.name.text || selectedProject.name} | Dustin Sparks`
      }

      if (projectId && shouldUpdateHistory && this.props.location.pathname !== `/${projectId}`) {
        this.props.history.push(`/${projectId}`)
      }

      return { projectId, projects }
    })
  }

  selectHeader () {
    document.querySelector('.djs-header').focus()

    // redux action, remove selected project.
    this.setState((prevState, props) => {
      if (prevState.projectId !== null) {
        document.title = `Resumé | Dustin Sparks`
        this.props.history.push(`/`)
      }
      return { projectId: null }
    })
  }

  deselectHeader () {
    this.selectProject(this.state.projectId)
  }

  componentWillReceiveProps (nextProps) {
    this.selectProject(nextProps.match.params.projectId, false)
  }

  componentDidMount () {
    fetch('https://animated-rope-363.firebaseio.com/projects.json').then((data) => data.json()).then((projectData) => {
      // redux action, set project list.
      this.setState((prevState, props) => {
        projectData = [ ...projectData ]
        let tech = props.match.params.tech
        // let role = props.match.role;
        if (tech) {
          projectData = projectData.filter((value, index, arr) => value.tech && value.tech.indexOf(tech) >= 0)
          console.log(projectData)
        }
        return { projects: projectData.sort((a, b) => a.year - b.year) }
      }, () => {
        if (this.state.projectId) {
          this.selectProject(this.state.projectId, false)
        }
      })
    })
  }

  listYears () {
    let years = {}
    if (!this.state.projects) { return [] }
    [...this.state.projects].map((project, index) => {
      if (typeof years[project.year] === 'undefined') {
        years[project.year] = []
      }

      years[project.year].push(project)

      if (project.selected) years[project.year].selected = true

      return project
    })

    let listProjectsWithYear = (year, yearIndex) => {
      return year.map((project, projectIndex) => {
        if (project.selected) year.selected = true

        project.index = (yearIndex + 1) * 10 + (projectIndex + 1)

        return <Project close={this.selectHeader.bind(this)} selectProject={this.selectProject.bind(this)} project={project} key={project.id} revealSecrets={this.state.revealSecrets} />
      })
    }

    return Array.prototype.map.call(Object.keys(years), (year, index) => {
      year = years[year]

      let classes = classnames({
        'djs-project-group': true,
        'djs-project-group--selected': year.selected
      })

      return (
        <div className={classes} key={year[0].year}>
          <Year year={year[0].year} key={`year_${year[0].year}_${index}`} />
          <div className='djs-project-group--flex'>
            {listProjectsWithYear(year, index)}
          </div>
        </div>
      )
    })
  }

  listProjects () {
    let years = []
    let year = this.state.projects[0].year

    let projects = this.state.projects.map((project, index) => {
      project.index = index + 2

      if (project.year !== year || index === this.state.projects.length - 1) {
        years.push({ index, year })
        year = project.year
      }

      project.componentRef = <Project close={this.selectHeader.bind(this)} selectProject={this.selectProject.bind(this)} project={project} key={project.id} />

      return project.componentRef
    })

    years.map((item, index) => {
      projects.splice(item.index, 0, <Year year={item.year} index={index} key={`year_${item.year}_${index}`} />)

      return item
    })

    return projects
  }

  render () {
    return (
      <div>
        <Header selected={!this.props.match.params.projectId} select={this.selectHeader.bind(this)} deselect={this.deselectHeader.bind(this)} />
        <div className='djs-scrollfield'>
          <main className={classnames({'djs-projects': true, 'djs-projects--selected': !!this.props.match.params.projectId})}>
            {this.listYears()}
          </main>
        </div>
      </div>
    )
  }
}

export default withRouter(Projects)



// WEBPACK FOOTER //
// ./src/pages/Projects/Projects.js